import { useLang } from '@/i18n';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import EfImg from 'elem/ui/ef-img';
import EfTitle from 'elem/ui/ef-title';
import { useRouter } from 'next/router';
import css from './Dialog.module.scss';
import { useState, useEffect } from 'react';

export default function Dialog({ configs, callback }: any) {
    const { t } = useLang('theProduct.OtherA');
    const { locale } = useRouter();
    const [checkedArr, setCheckArr] = useState([]);
    const [props, setProps] = useState(JSON.parse(JSON.stringify(configs)));

    const handleCheck = (arr: any) => {
        const checked = arr?.filter((p: any) => p.checked);
        setCheckArr(checked);
    };

    useEffect(() => {
        setCheckArr(configs?.productList?.filter((p: any) => p.checked));
    }, []);

    useEffect(() => {
        if (checkedArr?.length > 0) {
            const multipleVal = checkedArr.map((v: any) => v.value);
            setProps({
                contactListId: ['147986536', '2042660893', '876714684'],
                fields: [
                    {
                        id: '11571',
                        type: 'multiple',
                        value: multipleVal,
                        overwrite: false,
                    },
                    {
                        id: '4433',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '9537',
                        type: 'multiple',
                        value: [13],
                        overwrite: false,
                    },
                ],
            });
        }
    }, [checkedArr, locale]);

    return (
        <div className={css.Dialog}>
            <div className="content">
                <div className="img-h5">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1725089219087/%E5%BC%B9%E7%AA%97%E8%83%8C%E6%99%AF.jpg" />
                </div>
                <p className="close" onClick={callback}>
                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="50" height="50" rx="25" fill="#F4F4F4" />
                        <path d="M34.375 34.375L15.625 15.625" stroke="#707070" strokeWidth="4.5509" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M34.375 15.625L15.625 34.375" stroke="#707070" strokeWidth="4.5509" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </p>
                <div className="dialog-body">
                    <EfTitle hasAnimation={false}>{t('win_title1')}</EfTitle>
                    <div className="inner-box">
                        <EfImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1725089218921/%E5%BC%B9%E7%AA%97.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1725089219087/%E5%BC%B9%E7%AA%97%E8%83%8C%E6%99%AF.jpg"
                        />
                        <div className="info-box">
                            <p className="info-title">{t('win_title2')}</p>
                            <EfEmarsysEmail {...configs} {...props} callbackCheck={(arr: any) => handleCheck(arr)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
